// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2mR_b","col":"Table_col__1UaeD","fulfillmentStatus":"Table_fulfillmentStatus__vXOYu","emailCol":"Table_emailCol__NSL84"};